// virgin red
export const red = {
  red1: '#FCE7E7',
  red2: '#F8C4C4',
  red3: '#F29696',
  red4: '#EC6565',
  red5: '#E63636',
  red6: '#E10A0A',
  red7: '#BF0909',
  red8: '#A00707',
  red9: '#800606',
  red10: '#650505',
}

export const pink = {
  pink1: '#FFFEFE',
  pink2: '#FFFBFB',
  pink3: '#FEF9F9',
  pink4: '#FEF4F4',
  pink5: '#FDEFEF',
  pink6: '#FDEDED',
  pink7: '#FCEAEA',
  pink8: '#FCE9E9',
  pink9: '#FCE8E8',
  pink10: '#FCE6E6',
}

export const black = {
  black1: '#E9EBF8',
  black2: '#DDDDDD',
  black3: '#C6C6C6',
  black4: '#989898',
  black5: '#6A6A6A',
  black6: '#585858',
  black7: '#3C3C3C',
  black8: '#353535',
  black9: '#2C2C2C',
  black10: '#1A1A1A',
}

export const white = '#FFFFFF'
export const transparent = 'transparent'

export const color = {
  ...red,
  ...pink,
  ...black,
  white,
  transparent,
}
